/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					// Mobile product recommendations are injected after the section
					// starts hidden. Native lazy-loading can remain dormant on some
					// mobile browsers after that display transition. Force only these
					// recommendation images to become loadable once the HTML is injected.
					if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
						this.querySelectorAll('.product-primary-image').forEach((image) => {
							if (image.dataset.wsMobileSrc) {
								image.src = image.dataset.wsMobileSrc;
								image.srcset = image.dataset.wsMobileSrcset || image.srcset;
								image.sizes = image.dataset.wsMobileSizes || image.sizes;
							}
							image.loading = 'eager';
						});
				}

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
